import store from '../store'


export default function authHeader() {
    //let user = JSON.parse(localStorage.getItem('user'));
//    let user = localStorage.getItem('user');
//    let token = localStorage.getItem('token');

    if ('' != store.state.token) {
        return { 'x-access-token': store.state.token };
    } else {
        return {};
    }
}
